import api, {
    MutationRequestOptions,
    getMutationRequestConfig,
} from '../utils/axiosConfig'
import {
    PackageDeviceListResponse,
    PackageDeviceQueryParams,
    PackageDeviceRow,
    PackageDeviceUpdate,
    PackageManagementOptionsResponse,
    PackageProjectListResponse,
    PackageProjectQueryParams,
} from '../types/packageManagement'
import { normalizeSearchText } from '../utils/searchText'

const normalizeAllValue = <T extends string>(
    value?: T | 'all'
): T | undefined => (value && value !== 'all' ? value : undefined)

export const getPackageProjects = async (
    params: PackageProjectQueryParams
): Promise<PackageProjectListResponse> => {
    const response = await api.get('/package-management/projects', {
        params: {
            page: params.page,
            pageSize: params.pageSize,
            projectName: normalizeSearchText(params.projectName) || undefined,
            projectId: params.projectId,
            region: params.region || undefined,
            regionId: params.regionId,
            statusFilter: normalizeAllValue(params.statusFilter),
        },
    })
    return response.data
}

export const getPackageProjectDevices = async (
    projectId: number,
    params: PackageDeviceQueryParams
): Promise<PackageDeviceListResponse> => {
    const response = await api.get(
        `/package-management/projects/${projectId}/devices`,
        {
            params: {
                page: params.page,
                pageSize: params.pageSize,
                deviceName: normalizeSearchText(params.deviceName) || undefined,
                deviceVersion: normalizeAllValue(params.deviceVersion),
                deviceStatus: normalizeAllValue(params.deviceStatus),
                lureStart: params.lureStart,
                lureEnd: params.lureEnd,
            },
        }
    )
    return response.data
}

export const getPackageManagementOptions =
    async (): Promise<PackageManagementOptionsResponse> => {
        const response = await api.get('/package-management/options')
        return response.data
    }

export const updatePackageDevice = async (
    deviceId: string,
    payload: PackageDeviceUpdate,
    options?: MutationRequestOptions
): Promise<PackageDeviceRow> => {
    const response = await api.patch(
        `/package-management/devices/${deviceId}`,
        payload,
        getMutationRequestConfig(options)
    )
    return response.data
}
